import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import { Navigation } from 'swiper/modules';

import constant from "../../../../utils/constants";

const Catalogue = ({
  category,
  identifier,
  data,
  setUserSelection,
  selectedItems,
  title,
  rarityList,
  campaign
}) => {
  const [bgRarity, setBgRarity] = useState([]);
  const [ptRarity, setPtRarity] = useState([]);
  const [lcRarity, setLcRarity] = useState([]);
  const [tooltipText, setTooltipText] = useState("");
  const [showRarityBox, setShowRarityBox] = useState(false);

  let backgroundRarity = [];
  let patternRarity = [];
  let layerChoiceRarity = [];
  useEffect(() => {
    if (rarityList !== undefined) {
      rarityList.forEach((rarity) => {
        if (rarity.rarity_type === "background") {
          backgroundRarity.push({
            type: constant.BACKGROUND_COLOR,
            id: rarity.id_of_type,
            start: rarity.starts_on,
            end: rarity.ends_on,
            remainingCounter: Math.max(
              rarity.max_count - rarity.currentcount,
              0
            ),
            totalAllowed: rarity.max_count,
          });
        } else if (rarity.rarity_type === "pattern" || rarity.rarity_type === "base image") {
          patternRarity.push({
            type: constant.PATTERN,
            id: rarity.id_of_type,
            start: rarity.starts_on,
            end: rarity.ends_on,
            remainingCounter: Math.max(
              rarity.max_count - rarity.current_count,
              0
            ),
            totalAllowed: rarity.max_count,
          });
        } else if (rarity.rarity_type === "layerchoice") {
          layerChoiceRarity.push({
            type: constant.LAYER_CHOICE,
            id: rarity.id_of_type,
            start: rarity.starts_on,
            end: rarity.ends_on,
            remainingCounter: Math.max(
              rarity.max_count - rarity.current_count,
              0
            ),
            totalAllowed: rarity.max_count,
          });
        }
      });
      setBgRarity(backgroundRarity);
      setPtRarity(patternRarity);
      setLcRarity(layerChoiceRarity);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rarityList]);

  const getConditionalStyle = (item, index) => {
    if (category === "background") {
      return {
        backgroundColor: item.color_hex_code,
      };
    } else if (category === "pattern") {
      return {
        backgroundImage: `url(${item.thumbnail_url})`,
        backgroundPosition: "center",
      };
    } else if (category === "layerchoice") {
      return {
        backgroundImage: `url(${item.thumbnail_url})`,
        backgroundPosition: "center",
      };
    }
  };

  const getRarityStyle = (item) => {
    if (category === "background") {
      return bgRarity.some((br) => br.id === item.background_id);
    } else if (category === "pattern") {
      return ptRarity.some((pr) => pr.id === item.pattern_id);
    } else if (category === "layerchoice") {
      return lcRarity.some((lcr) => lcr.id === item.layerChoice_id);
    }
  };

  const calculateDate = (itemRarity, index) => {
    let startDate = itemRarity[index].start
      ? new Date(itemRarity[index].start)
      : null;
    let endDate = itemRarity[index].end
      ? new Date(itemRarity[index].end)
      : null;
    return { startDate, endDate };
  };

  const updateTooltip = (itemRarity, id) => {
    if (itemRarity.some((ir) => ir.id === id)) {
      let index = itemRarity.findIndex((ir) => ir.id === id);
      if (itemRarity[index] !== undefined) {
        let availableNfts = itemRarity[index].remainingCounter;
        let totalAllowed = itemRarity[index].totalAllowed;
        let type = itemRarity[index].type;
        let tooltipMsg = `Rarity of this ${type}:`;

        let dates = calculateDate(itemRarity, index);
        if (dates.startDate && dates.endDate)
          tooltipMsg += `<br>- Mint from ${dates.startDate} to ${dates.endDate}. `;
        else if (dates.endDay)
          tooltipMsg += `<br>- Minting ends on ${dates.endDay}. `;

        if (availableNfts > 0) {
          tooltipMsg += `<br>- Only ${availableNfts} of ${totalAllowed} left.`;
        }
        setTooltipText(tooltipMsg);
        setShowRarityBox(true);
      }
    } else {
      setTooltipText("");
      setShowRarityBox(false);
    }
  };

  const hideRarityDetails = () => {
    setTooltipText("");
    setShowRarityBox(false);
  };

  const getRarityTooltip = (item) => {
    if (category === "background") {
      updateTooltip(bgRarity, item.background_id);
    } else if (category === "pattern") {
      updateTooltip(ptRarity, item.pattern_id);
    } else if (category === "layerchoice") {
      updateTooltip(lcRarity, item.layer_choice_id);
    }
  };

  

  const showPrice = (item) => {
    if (category === "background") {
      if (item.price)
        return <h4 className="bg-price">{`${item.price} AVAX`}</h4>;
      else {
        if (campaign?.campaign_id) {
          return <h4 className="bg-price">0 AVAX</h4>
        }
        else {
          return <h4 className="bg-price"></h4>
        }
      }
    }
  };

  const isSelected = (item) => {
    if (category === "background") {
      return (
        selectedItems[identifier] &&
        item.background_id === selectedItems[identifier].background_id
      );
    } else if (category === "pattern") {
      return (
        selectedItems[identifier] &&
        item.pattern_id &&
        item.pattern_id === selectedItems[identifier].pattern_id
      );
    } else if (category === "layerchoice") {
      return (
        selectedItems[identifier] &&
        item.layer_choice_id &&
        item.layer_choice_id === selectedItems[identifier].layer_choice_id
      );
    }
  };

  const updateSelection = (item) => {
    const selectedItem = { ...item, category };
    if (category === "pattern") {
      for(const choice in selectedItems){
        if(selectedItems[choice].category === "layerchoice"){
          delete selectedItems[choice];
        }
      }
      selectedItems.pattern = selectedItem;
      setUserSelection(selectedItems);
    } else {
      setUserSelection({ [identifier]: selectedItem });
    }
  };

  const renderContent = () => {
    if (data && data.length > 0) {
      return (
        <>
          <h3 className="mint__step-title">{title}</h3>
          <div className="mint__bg-box">
            <Swiper
              navigation={true} 
              modules={[Navigation]}
              slidesPerView={5}
              spaceBetween={5}
              className="mySwiper"
            >
                {data.map((item, index) => (
                  
                  <SwiperSlide key={`catalogue-${index}`}>
                    <div className="bg-palette__info">
                      <div
                        className={`bg-box__wrapper ${
                          isSelected(item) ? "bg-box__wrapper--selected" : ""
                        }`}
                      >
                        <div
                          className="bg-box"
                          style={getConditionalStyle(item, index)}
                          onClick={() => updateSelection(item)}
                          onMouseEnter={() => getRarityTooltip(item)}
                          onMouseLeave={() => hideRarityDetails()}
                        >
                          {getRarityStyle(item) && (
                            <span className="rare-label">Rare</span>
                          )}
                        </div>
                      </div>
                      {showPrice(item)}
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
          {showRarityBox && (
            <div className="rarity-box">
              <span
                className="rarity-text"
                dangerouslySetInnerHTML={{ __html: tooltipText }}
              ></span>
            </div>
          )}
        </>
      );
    }
  };

  return <React.Fragment>{renderContent()}</React.Fragment>;
};

export default React.memo(Catalogue);
